var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1F64F(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#92d3f5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.167 68H4V56.333l15-7.5C16.397 57.37 26.455 63.39 31.5 60.5L27.167 68zM46.292 68h23.166V56.333l-15-7.5c2.604 8.537-7.455 14.557-12.5 11.667l4.334 7.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fcea2b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.83 61.109c-6.176 0-11.173-4.789-11.173-10.707 6.625-4.02 7.28-13.84 7.968-19.465.5-2.89 1.792-2.89 2.25-5.78L31.5 7.346C32.125 4 36.079 4.342 36.73 7v46.917c0 1.934-2.897 3.5-3.897 3.5-.812 0-3.003 3.03-3.003 3.692zM43.628 61.109c6.176 0 11.173-4.789 11.173-10.707-6.625-4.02-7.28-13.84-7.968-19.465-.5-2.89-1.791-2.89-2.25-5.78l-2.625-17.81C41.333 4 37.38 4.343 36.73 7v46.917c0 1.934 2.896 3.5 3.896 3.5.813 0 3.003 3.03 3.003 3.692z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.167 68H4V56.333l15-7.5C16.397 57.37 26.455 63.39 31.5 60.5L27.167 68z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.83 61.109c0-.663 2.19-3.692 3.003-3.692 1 0 3.896-1.566 3.896-3.5V7c-.65-2.658-4.604-3-5.229.347l-2.625 17.81c-.458 2.89-1.75 2.89-2.25 5.78-.688 5.625-1.343 15.444-7.968 19.465M46.292 68h23.166V56.333l-15-7.5c2.604 8.537-7.455 14.557-12.5 11.667l4.334 7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.628 61.109c0-.663-2.19-3.692-3.003-3.692-1 0-3.896-1.566-3.896-3.5V7c.65-2.658 4.604-3 5.23.347l2.624 17.81c.459 2.89 1.75 2.89 2.25 5.78.688 5.625 1.343 15.444 7.968 19.465"
  }))));
}
export default Svg1F64F;